import React from "react";
import Markdown from "markdown-to-jsx";
import { CopyIcon } from "@merge-api/merge-javascript-shared";

interface Props {
  text: string;
  response_id: string;
}

export const MarkdownMessage: React.FC<Props> = ({ text, response_id }) => (
  <Markdown
    data-response-id={response_id}
    className="p-[15px] bg-[#eaeae9] prose-h5:text-black prose-h6:text-black rounded-lg max-w-[100%] prose prose-sm prose-li:marker:text-black prose-hr:my-[4px] overflow-x-auto"
    options={{
      overrides: {
        code: {
          component: ({ className, children }) => {
            const codeString = Array.isArray(children) ? children.join("") : String(children);

            return (
              <code className={`${className} before:content-none after:content-none`}>
                {codeString}
              </code>
            );
          },
        },
        a: {
          component: ({ href, children, ...props }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
              {children}
            </a>
          ),
        },
        pre: {
          component: ({
            children,
            ...props
          }: React.PropsWithChildren<{
            [key: string]: unknown;
          }>) => {
            // Extract the code content from pre > code structure
            let codeContent = "";

            // Find the code element and extract its content
            if (children && React.isValidElement(children)) {
              const codeElement = children;
              // Create a type-safe version of the element props
              const elementProps = codeElement.props as { children?: React.ReactNode };

              if (elementProps.children) {
                // Safely extract the content
                if (Array.isArray(elementProps.children)) {
                  codeContent = elementProps.children.map(String).join("");
                } else {
                  codeContent = String(elementProps.children);
                }
              }
            }

            return (
              <div className="relative">
                <pre {...props}>{children}</pre>
                <div className="absolute right-2 top-2">
                  <CopyIcon text={codeContent} size={12} />
                </div>
              </div>
            );
          },
        },
        table: {
          component: ({ children, ...props }) => (
            <div className="overflow-x-auto">
              <table {...props} className="min-w-full">
                {children}
              </table>
            </div>
          ),
        },
        img: {
          component: ({ src, alt }) => (
            <div className="max-w-[100px] max-h-[100px] w-[100px] h-[100px] overflow-hidden flex items-center justify-center">
              <img src={src} alt={alt || ""} className="w-full h-full object-contain" />
            </div>
          ),
        },
      },
    }}
  >
    {text}
  </Markdown>
);
